import React, {PropTypes} from 'react';

const PageQuote = ({quote, quoteBy}) => {
  return (
    <div className="page-quote-container">
      <div className="page-quote-content">
        <div className="page-quote">
          "{quote}"
        </div>
        <div className="page-quote-by">
          {quoteBy}
        </div>
      </div>
    </div>
  );
};

PageQuote.propTypes = {
  quote: PropTypes.string.isRequired,
  quoteBy: PropTypes.string.isRequired
};

export default PageQuote;



/** WEBPACK FOOTER **
 ** ./src/components/common/PageQuote.js
 **/